import { CoingeckoPricesResData } from 'modules/coingecko'
import { DetailedOrder } from 'modules/offer/types'
import { isAddressContained, isAddressEqual } from 'utils/web3'

export const parseMyOrdersWithPrice = (
  order: DetailedOrder,
  curatedStablecoins: string[],
  prices: CoingeckoPricesResData,
  targetToken: string | undefined
) => {
  let price = order.sellAmount / order.buyAmount
  let priceSymbol = order.sellToken.symbol
  let priceUSD =
    Number(prices[order.sellToken.address]) > 0
      ? (order.sellAmount / order.buyAmount) *
        Number(prices[order.sellToken.address])
      : 0
  let hideUSD = false
  // Hide priceUsd if denominated asset is a stablecoin
  if (isAddressContained(order.sellToken.address, curatedStablecoins)) {
    hideUSD = true
    priceUSD = order.sellAmount / order.buyAmount
  }

  // Fix if BUY denominated asset is unlocked
  if (targetToken && isAddressEqual(order.buyToken.address, targetToken)) {
    price = order.sellAmount / order.buyAmount
    priceSymbol = order.sellToken.symbol
    priceUSD =
      Number(prices[order.sellToken.address]) > 0
        ? (order.sellAmount / order.buyAmount) *
          Number(prices[order.sellToken.address])
        : 0
    hideUSD = false
    // Hide priceUsd if denominated asset is a stablecoin
    if (isAddressContained(order.sellToken.address, curatedStablecoins)) {
      hideUSD = true
      priceUSD = order.sellAmount / order.buyAmount
    }
  }
  // Fix if SELL denominated asset is unlocked
  if (targetToken && isAddressEqual(order.sellToken.address, targetToken)) {
    price = order.buyAmount / order.sellAmount
    priceSymbol = order.buyToken.symbol
    priceUSD =
      Number(prices[order.buyToken.address]) > 0
        ? (order.buyAmount / order.sellAmount) *
          Number(prices[order.buyToken.address])
        : 0
    hideUSD = false
    // Hide priceUsd if denominated asset is a stablecoin
    if (isAddressContained(order.buyToken.address, curatedStablecoins)) {
      hideUSD = true
      priceUSD = order.buyAmount / order.sellAmount
    }
  }
  return {
    _id: order._id,
    symbol: order.sellToken.symbol,
    sellToken: order.buyToken.address,
    sellAmount: order.buyAmount,
    sellTokenSymbol: order.buyToken.symbol,
    buyToken: order.sellToken.address,
    buyAmount: order.sellAmount,
    buyTokenSymbol: order.sellToken.symbol,
    price,
    priceUSD,
    hideUSD,
    priceSymbol,
    expiry: order.expiry,
  }
}
export const parseBuyOrdersWithPrice = (
  order: DetailedOrder,
  curatedStablecoins: string[],
  prices: CoingeckoPricesResData
) => {
  let priceUSD =
    Number(prices[order.buyToken.address]) > 0
      ? (order.buyAmount / order.sellAmount) *
        Number(prices[order.buyToken.address])
      : 0
  let hideUSD = false
  // Hide priceUsd if denominated asset is a stablecoin
  if (isAddressContained(order.buyToken.address, curatedStablecoins)) {
    hideUSD = true
    priceUSD = order.buyAmount / order.sellAmount
  }
  return {
    _id: order._id,
    symbol: order.sellToken.symbol,
    sellToken: order.sellToken.address,
    sellAmount: order.sellAmount,
    sellTokenSymbol: order.sellToken.symbol,
    buyToken: order.buyToken.address,
    buyAmount: order.buyAmount,
    buyTokenSymbol: order.buyToken.symbol,
    price: order.buyAmount / order.sellAmount,
    priceUSD,
    hideUSD,
    priceSymbol: order.buyToken.symbol,
    expiry: order.expiry,
  }
}
export const parseSellOrdersWithPrice = (
  order: DetailedOrder,
  curatedStablecoins: string[],
  prices: CoingeckoPricesResData
) => {
  let priceUSD =
    Number(prices[order.sellToken.address]) > 0
      ? (order.sellAmount / order.buyAmount) *
        Number(prices[order.sellToken.address])
      : 0
  let hideUSD = false
  // Hide priceUsd if denominated asset is a stablecoin
  if (isAddressContained(order.sellToken.address, curatedStablecoins)) {
    hideUSD = true
    priceUSD = order.sellAmount / order.buyAmount
  }
  return {
    _id: order._id,
    symbol: order.buyToken.symbol,
    sellToken: order.sellToken.address,
    sellAmount: order.sellAmount,
    sellTokenSymbol: order.sellToken.symbol,
    buyToken: order.buyToken.address,
    buyAmount: order.buyAmount,
    buyTokenSymbol: order.buyToken.symbol,
    price: order.sellAmount / order.buyAmount,
    priceUSD,
    hideUSD,
    priceSymbol: order.sellToken.symbol,
    expiry: order.expiry,
  }
}
